import { render } from "./DashBoard.vue?vue&type=template&id=33830410&scoped=true"
import script from "./DashBoard.vue?vue&type=script&lang=js"
export * from "./DashBoard.vue?vue&type=script&lang=js"

import "./DashBoard.vue?vue&type=style&index=0&id=33830410&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/chaizen_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33830410"]])

export default __exports__